<template>
<div>
    <b-container >
        <b-row>
            <b-col cols="12">
                <h1 class="teamTitle">TEAM</h1>

                <br><br><br><br>

                <section class="team">
                <div class="grid-xlarge">
                    <div class="team__container">
                    <article v-for="people in team" :key="people">
                        <a class="team__link" :href="people.twitter" target="_blank">
                        <div class="team__img-container">
                            <span class="preloader"></span>
                            <figure class="team__img">
                            <img class="absolute-bg" :src=people.img alt=""/>
                                        </figure>
                        </div>
                        <div class="team__text">
                            <h3 class="team__title">{{people.name}}</h3>
                            <span class="team__position">{{people.position}}</span>
                            <span v-if="people.desc" class="team__desc">{{people.desc}}</span>
                            <b-icon class="social" icon="twitter" font-scale="1"></b-icon>
                        </div>
                        </a>
                    </article>
                    </div>
                </div>
                </section>
            </b-col>
        </b-row>
    </b-container>


    
</div>
</template>

<script>
import ampImg from '../../assets/team/Amp.jpg';
import cryptoImg from '../../assets/team/Cryptobulls.jpg';
import degenImg from '../../assets/team/DegenChicken.png';
import legatoImg from '../../assets/team/LegatoFP.jpg';
import magicImg from '../../assets/team/magicmama.png';
import pachanImg from '../../assets/team/Pachan.jpg';
import saltyImg from '../../assets/team/Saltylollipop.png';
import xenImg from '../../assets/team/Xen.png';
import yingImg from '../../assets/team/Ying356.jpg';
import princessImg from '../../assets/team/Princ3ss.jpg';
import rq from '../../assets/team/rq.jpg';
import beast from '../../assets/team/BEA5T.png';

export default {
    data: function () {
        return {
            team:[
                {twitter:"https://twitter.com/LegatoFP", name: "LegatoFP", position:"Founder", desc: "DWC: Collab Manager\nNFT Nato: Research Team", img: legatoImg},
                {twitter:"https://twitter.com/Official_Chonii", name: "RQ", position:"Dev",  desc: "DWC: Dev\nCosmic Labs: Dev", img:rq},
                {twitter:"https://twitter.com/iamcryptobulls", name: "Cryptobulls", position:"Manager",  desc: "DWC: Manager\nCryptoCopyCats: Manager\nTop Luxury Brand: Senior Project Manager", img: cryptoImg},
                {twitter:"", name: "Degen Chicken", position:"Alpha Dealer", desc: "Llamaverse: Alpha Caller", img: degenImg},
                {twitter:"", name: "Princ3ss",  position: "Team Member", img: princessImg},
                {twitter:"https://twitter.com/magicmamacrypto", name: "Magic Mama Crypto", position:"Team Member", desc: "DWC Mod", img:magicImg},
                {twitter:"", name: "Pachan",  position: "Collab Manager", img: pachanImg},
                {twitter:"https://twitter.com/saltylollipop69", name: "Saltylollipop",  position: "Alpha Dealer", img: saltyImg},
                {twitter:"https://twitter.com/xenuity", name: "Xen",  position: "Team Member", img:xenImg},
                {twitter:"https://twitter.com/TheAlphaPalace", name: "Ying356",  position: "Alpha Dealer", img:yingImg},
                {twitter:"https://twitter.com/Amp9666", name: "Amp", position: "Alpha Dealer", img: ampImg },
                {twitter:"", name: "BEA5T", position:"Team Member", img:beast},
            ]
        }
    },
    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style scoped>
.teamTitle
{
    margin-top: 10vh;
    font-size: 10vh;
    font-weight: 700;
    background: linear-gradient(180deg, rgba(255,237,101,1) 20%, rgba(215,148,61,1) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent; 
    -moz-text-fill-color: transparent;
    margin-bottom: 10vh;
}
.teamCard
{
    float: left;
    margin-left: 0.75vh;
    margin-right: 0.75vh;
    display: flex !important;
    width: 300px;
    background: #000000;
    border: 6px solid rgba(215,148,61,1);
    box-sizing: border-box;
    color: white;
    border-radius: 24px;
    margin-bottom: 2vh;
    height: 300px;
}
.teamCardMobile
{
    margin-left: 0.75vh;
    margin-right: 0.75vh;
    background: #000000;
    border: 6px solid rgba(215,148,61,1);
    box-sizing: border-box;
    color: white;
    border-radius: 24px;
    margin-bottom: 2vh;
    height: 310px;
}
.teamImg
{
    border-radius: 12px;
    width: 130px;
    height: 130px;
}
.teamPosition
{
    font-size: 1vh;
}
.teamName
{
    font-size: 1.5vh;
    color: rgba(255,237,101,1);
    margin-top: 2vh;
    margin-bottom: 1vh;
}
.teamDesc
{
    font-size: 1vh;
    white-space: pre-wrap;
    line-height: 2vh;
    color: rgb(253, 244, 170);
}



.social
{
    color: #00acee;
    margin-top: 2vh;
}


.grid-xlarge {
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 54em) {
  .grid-xlarge {
    width: 95%;
  }
}
@media (min-width: 91em) {
  .grid-xlarge {
    width: 80%;
  }
}

.absolute-bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  height: 100%;
  width: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
}

.preloader {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3em;
  width: 3em;
  margin: auto;
  border: 2px solid transparent;
  border-top-color: rgba(255,237,101,1);
  border-radius: 50%;
  opacity: 1;
  -webkit-animation: spin 1s linear infinite both;
          animation: spin 1s linear infinite both;
  transition: opacity 2s 0.2s ease-out;
}

@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.team {
  width: 100%;
  padding-right: 1em;
  padding-left: 1em;
}
.team__container {
  display: flex;
  flex-direction: row;
  flex-flow: wrap;
  margin-left: -1em;
  margin-right: -1em;
  align-items: center;
  justify-content: center;
}
.team__container > * {
  padding: 1em;
  flex-basis: 100%;
  max-width: 100%;
}
@media (min-width: 32em) {
  .team__container > * {
    flex-basis: 50%;
    max-width: 50%;
  }
}
@media (min-width: 54em) {
  .team__container > * {
    flex-basis: 50%;
    max-width: 50%;
  }
}
@media (min-width: 65em) {
  .team__container > * {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
  }
}
.team__link {
  position: relative;
  display: block;
  height: 100%;
  width: 100%;
  border: 1px solid transparent;
  background-clip: padding-box;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  -webkit-transform: translate3d(0, 0, 0);
          transform: translate3d(0, 0, 0);
  transition: all 1s ease;
}
.team__link:hover {
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 47px rgba(0, 0, 0, 0.1);
  -webkit-transform: translate3d(0, -0.5em, 0);
          transform: translate3d(0, -0.5em, 0);
}
.team__link:hover:after {
  opacity: 1;
}
.team__link:hover .team__title:after {
  left: 0;
  width: 100%;
}
.team__link:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-clip: padding-box;
  box-shadow: 0 2px 50px rgba(0, 0, 0, 0.2);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.team__header {
  margin-bottom: 2em;
  color: rgba(255,237,101,1);
  text-align: center;
}
.team__img-container {
  position: relative;
  background-color: #061c30;
}
.team__img {
  position: relative;
  padding-bottom: 100%;
  -webkit-animation: fade-in ease-in-out 1s both;
          animation: fade-in ease-in-out 1s both;
}
.team__text {
  padding: 1em 0.5em;
  color: #000;
  background-color: #fff;
  text-align: center;
}
@media (min-width: 32em) {
  .team__text {
    padding-top: 2em;
    padding-bottom: 2em;
  }
}
.team__title {
  position: relative;
  display: inline-block;
  /*
   * Add hover to pseudo element
   * left: 0;
   * width: 100%
   */
  margin-bottom: 0.35em;
}
.team__title:after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -0.1em;
  height: 2px;
  width: 0;
  background-color: rgba(255,237,101,1);
  transition: all 0.3s ease-in-out;
}
.team__position {
  display: block;
  font-size: 0.9em;
}

.team__desc {
  display: block;
  font-size: 0.6em;
  margin-top: 1vh;
  font-weight: bold;
  text-decoration: none !important;
  white-space: pre-wrap;
}

.team__desc:hover {
  color: rgba(215,148,61,1);
}
</style>


// WEBPACK FOOTER //
// src/components/homeComp/Team.vue